function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import TableContext from "./TableContext";
import { MenuOutlined } from '@ant-design/icons';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import React, { useContext } from 'react';
function RewardSortableItem(props) {
  var _useContext = useContext(TableContext),
    isFullRowDrag = _useContext.isFullRowDrag,
    sort = _useContext.sort;
  var id = props['data-row-key'];
  var _useSortable = useSortable({
      id: id,
      disabled: !sort
    }),
    attributes = _useSortable.attributes,
    listeners = _useSortable.listeners,
    setActivatorNodeRef = _useSortable.setActivatorNodeRef,
    setNodeRef = _useSortable.setNodeRef,
    transform = _useSortable.transform,
    transition = _useSortable.transition,
    isDragging = _useSortable.isDragging;
  var children = props.children;
  var style = _objectSpread(_objectSpread({}, props.style), {}, {
    transform: CSS.Translate.toString(transform),
    transition: transition
  }, isDragging ? {
    position: 'relative',
    zIndex: 9999
  } : {});
  return /*#__PURE__*/React.createElement(React.Fragment, null, isFullRowDrag ? /*#__PURE__*/React.createElement("tr", _extends({}, props, {
    ref: setNodeRef,
    style: _objectSpread(_objectSpread({}, style), {}, {
      cursor: sort ? 'move' : 'default'
    })
  }, attributes, listeners)) : /*#__PURE__*/React.createElement("tr", _extends({}, props, {
    ref: setNodeRef,
    style: style
  }), React.Children.map(children, function (child) {
    if (child.key === 'sort' && sort) {
      return /*#__PURE__*/React.cloneElement(child, {
        children: /*#__PURE__*/React.createElement("div", _extends({
          ref: setActivatorNodeRef,
          style: {
            touchAction: 'none',
            cursor: sort ? 'move' : 'default',
            width: '100%',
            height: '100%'
          }
        }, attributes, listeners), /*#__PURE__*/React.createElement(MenuOutlined, null))
      });
    }
    return child;
  })));
}
export default RewardSortableItem;